<template>
  <div class="wrapper" v-if="loaded">
    <TheHeader />
    <main class="main">
      <router-view />
    </main>
    <TheFooter />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TheHeader from '@blocks/TheHeader'
import TheFooter from '@blocks/TheFooter'

export default {
  name: 'LocaleView',
  data () {
    return {
      loaded: false
    }
  },
  components: {
    TheHeader,
    TheFooter
  },
  computed: {
    ...mapGetters({
      language: 'languages/getLanguage'
    })
  },
  watch: {
    language () {
      this.updateCommonData()
    },
    '$route' (to, from) {
      this.checkLanguage(to)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.checkLanguage(to)
    })
  },
  created () {
    this.updateCommonData()
  },
  methods: {
    ...mapActions({
      updateLanguage: 'languages/updateLanguage',
      updateToggle: 'header/updateToggle',
      checkAvailability: 'languages/checkAvailability',
      fetchGetCommon: 'common/fetchGetCommon'
    }),
    checkLanguage (to) {
      let nextLanguage = to.params.language
      this.checkAvailability(nextLanguage).then(response => {
        if (response) {
          this.updateLanguage(nextLanguage)
        } else {
          this.$router.replace({
            name: to.name,
            params: {
              language: 'fr'
            }
          })
        }
      })
    },
    updateCommonData () {
      this.fetchGetCommon()
        .then(() => {
          this.loaded = true
        })
    }
  }
}
</script>

<style lang="scss">
.locale-view{
  background-color: black;
}
</style>

  function newFunction(next) {
    next();
  }
